/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Operator for the condition
 */
export type IncidentRuleOperator = (typeof IncidentRuleOperator)[keyof typeof IncidentRuleOperator];

export const IncidentRuleOperator = {
  '=': '=',
  '!=': '!=',
  '>': '>',
  '>=': '>=',
  '<': '<',
  '<=': '<=',
} as const;
